<template>
    <a
        class="catalog-quick-filter rounded px-2 py-2 d-flex flex-align-center"
        :class="{ 'selected text-white bg-default-5': isSelected }"
        :href="url"
        @click="fetch"
    >
        <div class="mr-1">
            <component :is="iconsMap[value]" />
        </div>
        {{ label }}
    </a>
</template>

<script>
    import CatalogFilterLink from './CatalogFilterLink';
    import MaleShirtIcon from '../icon/MaleShirtIcon';
    import ApronIcon from '../icon/ApronIcon';
    import SockIcon from '../icon/SockIcon';
    import FlagIcon from '../icon/FlagIcon';
    import BagIcon from '../icon/BagIcon';
    import SketchbookIcon from '../icon/SketchbookIcon';
    import PosterIcon from '../icon/PosterIcon';
    import PhoneCaseIcon from '../icon/PhoneCaseIcon';
    import MugIcon from '../icon/MugIcon';

    export default {
        name: 'CatalogQuickFilter',

        extends: CatalogFilterLink,

        props: {
            isSelected: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                iconsMap: {
                    1: MaleShirtIcon, // camiseta
                    6: PosterIcon, // poster
                    15: PhoneCaseIcon, // capas
                    17: MugIcon, // caneca
                    18: SketchbookIcon, // sketchbook
                    25: BagIcon, // bolsa
                    31: ApronIcon, // avental
                    33: SockIcon, // meia
                    43: FlagIcon, // bandeira
                    45: MaleShirtIcon, // camisa
                },
            };
        },
    };
</script>
